export default import.meta.ROLLDOWN_FILE_URL_jOX8L4prGHllqMtq8nsjgQ